// extracted by mini-css-extract-plugin
export default {"accordions":"ConstructorAccordions_accordions__WDBgP"};